/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Faq_HeadingInputs */



/**
* | output |
* | --- |
* | "## FAQ" |
*
* @param {Og_Faq_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_faq_heading = /** @type {((inputs?: Og_Faq_HeadingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Faq_HeadingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("## FAQ")
	if (locale === "es") return /** @type {LocalizedString} */ ("## Preguntas frecuentes")
	if (locale === "pt") return /** @type {LocalizedString} */ ("## FAQ")
	if (locale === "it") return /** @type {LocalizedString} */ ("## FAQ")
	return /** @type {LocalizedString} */ ("## FAQ")
});